export const environment = {
  production: false,
  endpoint: process.env.REACT_APP_API_ENDPOINT,
  asset: process.env.REACT_APP_STATIC_ENDPOINT,
};
